export default __webpack_public_path__ + "static/media/image-ph-study-ranking-n-w@3x.cd81380f.webp";